module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img05-1e2683cbb763c83eb8dfae417cb3001c.png";